/** Public, build-time settings only. Never accept test routing from URL parameters. */
const previewMode = process.env.NEXT_PUBLIC_COMMERCE_TEST_PREVIEW;
if (previewMode !== undefined && previewMode !== 'true' && previewMode !== 'false') throw new Error('Invalid preview mode');
export const commerceTestPreview = previewMode === 'true';
export const testFirebaseAppName = 'nomiss-commerce-test-preview';
export const testDatabaseId = 'measurement-commerce-test';
export const measurementHandoffKey = commerceTestPreview ? 'nomiss-test-measurement-handoff' : 'nomiss-measurement-handoff';
export function assertTestPreview(): void {
  if (!commerceTestPreview) return;
  // Measurement ingress is cloud-only: never combine it with local Auth/Functions.
  if (process.env.NEXT_PUBLIC_USE_FIREBASE_EMULATOR === 'true' ||
      process.env.NEXT_PUBLIC_FIREBASE_EMULATOR === 'true') {
    throw new Error('検証専用画面ではエミュレータとの混在接続はできません。');
  }
  if (process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID !== 'nomiss--prj' ||
      process.env.NEXT_PUBLIC_COMMERCE_TEST_DATABASE_ID !== testDatabaseId ||
      process.env.NEXT_PUBLIC_COMMERCE_TEST_TENANT_ID === undefined ||
      process.env.NEXT_PUBLIC_DDD_COMMERCE_ENABLED !== 'true' ||
      !process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY?.startsWith('pk_test_')) {
    throw new Error('検証環境の接続設定が不完全です。通常環境への接続は行いません。');
  }
  const origin = process.env.NEXT_PUBLIC_COMMERCE_TEST_ORIGIN;
  if (!origin || new URL(origin).origin !== origin ||
      (!origin.startsWith('https://') && !/^http:\/\/(localhost|127\.0\.0\.1):\d+$/.test(origin))) {
    throw new Error('検証専用URLの設定が必要です。');
  }
  if (typeof window !== 'undefined' && window.location.origin !== origin) {
    throw new Error('許可された検証専用URLで開いてください。');
  }
}
const testFunctions = new Set(['quoteCommercePurchase', 'startViewerPurchase', 'getCommercePurchase',
  'getCommerceOrderHistory', 'postComment', 'linkMeasurementIdentity', 'beginMeasurementRegistration',
  'annotateMeasurement', 'exportMeasurementReport', 'downloadMeasurementReport',
  'measurementProcessingStatus', 'retryMeasurementDelivery', 'rebuildMeasurementProjection', 'recordMeasurementAnswer']);
export function commerceFunctionName(name: string): string {
  if (!commerceTestPreview) return name;
  assertTestPreview();
  if (!testFunctions.has(name)) throw new Error('このAPIは検証専用経路に接続されていません。');
  return `test${name[0].toUpperCase()}${name.slice(1)}`;
}
export function previewStripeKey(): string | undefined {
  assertTestPreview();
  return process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
}
export function testMeasurementEndpoint(): string {
  if (!commerceTestPreview) throw new Error('検証用ビルドではありません。');
  assertTestPreview();
  return 'https://asia-northeast1-nomiss--prj.cloudfunctions.net/testIngestMeasurement';
}
